module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var stepNumbers = [1,2,5,10];

    ; __append("\r\n\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\">Scale</span></div>\r\n<div class=\"main-slider-caption prop-detail\" >\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12 subsection nopadding-r\">\r\n                <label class=\"prop-sublabel label-30\">Step</label> \r\n                <div >\r\n                    <select name=\"tickInterval\" id=\"tickInterval\" class=\"label-40\">\r\n                        ")
    ;  for (var i = 0; i < stepNumbers.length; i++) { 
    ; __append("\r\n                            <option value=\"")
    ; __append(escapeFn(stepNumbers[i]))
    ; __append("\">")
    ; __append(escapeFn(stepNumbers[i]))
    ; __append("</option>\r\n                        ")
    ;  }; 
    ; __append("\r\n                    </select>\r\n                    <div class=\"label-90\" style=\"display: inline-block; margin-left: 5px;\"> \r\n                        <input id=\"tickColorPicker\" name=\"tickColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( tickColor ))
    ; __append("\" />\r\n                        <input id=\"tickColor\" type=\"text\" name=\"tickColor\" value=\"")
    ; __append(escapeFn( tickColor ))
    ; __append("\" maxlength=\"7\" class=\"color-picker-text\"/>   \r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n</div>")
  }
  return __output;

}